import React from "react";
//import loader from "../../assets/img/loading.gif";
import LinearProgress from "@material-ui/core/LinearProgress";
import { lighten, makeStyles, withStyles } from "@material-ui/core/styles";

export default function Loading({ className }) {
  const [completed, setCompleted] = React.useState(0);

  const ColorLinearProgress = withStyles({
    colorPrimary: {
      backgroundColor: "#ff0"
    },
    barColorPrimary: {
      backgroundColor: "#ff0"
    }
  })(LinearProgress);
  React.useEffect(() => {
    function progress() {
      setCompleted(oldCompleted => {
        if (oldCompleted === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldCompleted + diff, 100);
      });
    }

    const timer = setTimeout(progress, 500);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <div
      className={
        className === "reviewProcessLoading" ? "reviewProcessLoading" : ""
      }
    >
      <LinearProgress
        color="primary"
        variant="indeterminate"
        value={completed}
        className={className ? `LinearPro ${className}` : "LinearPro"}
      />
      {/* <img src={loader} /> */}
    </div>
  );
}
